import { urlGlobal2 } from "./GlobalService";

export const getSolicitudesCambios = async(params=null) => {
    let url = new URL(`${urlGlobal2}/solicitudescambios`)
    try{
        if (params != null) {
            url.search = new URLSearchParams(params).toString();   
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type':'application/json', token}
        let method = 'GET';
        let resp = await fetch(url,{method, headers});
        let data = await resp.json();
        return data;
    }
    catch(error){
        alert(error.message);
        return null;
    }
}
export async function postSolicitudesCambios(sc){
    let url = `${urlGlobal2}/solicitudescambios`;
    try {
        let token = localStorage.getItem('token');
        let headers = {'Content-Type':'application/json','token':token}
        let method= 'POST';
        let body = JSON.stringify(sc)
        const resp = await fetch(url, {headers, body, method});
        const data = await resp.json()
        return data;
    } catch (error) {
        
        return null;
    }
  }
  export async function putSolicitudesCambios(sc){
    let url = `${urlGlobal2}/solicitudescambios`;
    try {
        let token = localStorage.getItem('token');
        let headers = {'Content-Type':'application/json','token':token}
        let method= 'PUT';
        let body = JSON.stringify(sc)
        const resp = await fetch(url, {headers, body, method});
        const data = await resp.json()
        return data;
    } catch (error) {
        
        return null;
    }
  }

  export async function deleteSolicitudesCambios(id){
    let url = `${urlGlobal2}/solicitudescambios/${id}`;
    try {
        let token = localStorage.getItem('token');
        let headers = {'Content-Type':'application/json','token':token}
        let method= 'DELETE';
        const resp = await fetch(url, {headers, method});
        const data = await resp.json()
        return data;
    } catch (error) {
        
        return null;
    }
  }
